var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcademy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eUaBTMDQpJe1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 265 400",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    "project-id": "b0d36e6329f648aa851182a289442a79",
    "export-id": "0a60907056114e35acb35028f1944f80",
    cached: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe10-fill",
    x1: 819.213,
    y1: 635.519,
    x2: 870.811,
    y2: 635.519,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe10-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe10-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe11-fill",
    x1: 834.958,
    y1: 666.215,
    x2: 849.32,
    y2: 666.215,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe11-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe11-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe12-fill",
    x1: 722.955,
    y1: 611.366,
    x2: 745.907,
    y2: 589.987,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe12-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe12-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe24-fill",
    x1: 601.424,
    y1: 678.881,
    x2: 643.383,
    y2: 678.881,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe24-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe24-fill-1",
    offset: "69.1%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe32-fill",
    x1: 612.899,
    y1: 714.42,
    x2: 627.92,
    y2: 714.42,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe32-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe32-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe34-fill",
    x1: 621.392,
    y1: 713.826,
    x2: 642.599,
    y2: 713.826,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe34-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe34-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe36-fill",
    x1: 620.801,
    y1: 703.656,
    x2: 632.517,
    y2: 703.656,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe36-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe36-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe40-fill",
    x1: 696.572,
    y1: 839.883,
    x2: 746.402,
    y2: 839.883,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe40-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe40-fill-1",
    offset: "92.1%",
    stopColor: "#424849"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe43-fill",
    x1: 686.621,
    y1: 804.981,
    x2: 697.108,
    y2: 778.12,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe43-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe43-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe46-fill",
    x1: 640.486,
    y1: 800.127,
    x2: 697.943,
    y2: 724.765,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe46-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe46-fill-1",
    offset: "86%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe48-fill",
    x1: 702.5,
    y1: 811.866,
    x2: 715.593,
    y2: 789.683,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe48-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe48-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe51-fill",
    x1: 729.899,
    y1: 805.242,
    x2: 740.687,
    y2: 786.965,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe51-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe51-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe54-fill",
    x1: 729.549,
    y1: 826.074,
    x2: 741.181,
    y2: 806.341,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe54-fill-0",
    offset: "32.5%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe54-fill-1",
    offset: "85.6%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe55-fill",
    x1: 767.671,
    y1: 829.849,
    x2: 736.292,
    y2: 865.917,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe55-fill-0",
    offset: "32.5%",
    stopColor: "#d86257"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe55-fill-1",
    offset: "100%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe56-fill",
    x1: 683.047,
    y1: 793.034,
    x2: 690.626,
    y2: 770.296,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe56-fill-0",
    offset: "12.8%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe56-fill-1",
    offset: "52.9%",
    stopColor: "#ed956e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe58-fill",
    x1: 764.272,
    y1: 779.225,
    x2: 741.198,
    y2: 802.852,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe58-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe58-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe59-fill",
    x1: 734.283,
    y1: 780.251,
    x2: 721.46,
    y2: 792.392,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe59-fill-0",
    offset: "25.5%",
    stopColor: "#25254e"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe59-fill-1",
    offset: "100%",
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe69-fill",
    x1: 691.617,
    y1: 797.599,
    x2: 704.811,
    y2: 784.767,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe69-fill-0",
    offset: "1.9%",
    stopColor: "#d65764"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe69-fill-1",
    offset: "63%",
    stopColor: "#ffc6a6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe72-fill",
    x1: 720.903,
    y1: 747.327,
    x2: 748.826,
    y2: 747.327,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe72-fill-0",
    offset: "5.6%",
    stopColor: "#ffddc9"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe72-fill-1",
    offset: "77.1%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe79-fill",
    x1: 731.075,
    y1: 789.96,
    x2: 724.588,
    y2: 800.728,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe79-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe79-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe85-fill",
    x1: 756.07,
    y1: 791.125,
    x2: 750.615,
    y2: 800.181,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe85-fill-0",
    offset: "0%",
    stopColor: "#ffcfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe85-fill-1",
    offset: "99.5%",
    stopColor: "#ffb88c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe91-fill",
    x1: 736.159,
    y1: 813.275,
    x2: 742.902,
    y2: 826.579,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe91-fill-0",
    offset: "4%",
    stopColor: "#b22842"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe91-fill-1",
    offset: "21.3%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe91-fill-2",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe92-fill",
    x1: 727.513,
    y1: 811.457,
    x2: 729.975,
    y2: 811.457,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe92-fill-0",
    offset: "0%",
    stopColor: "#d34f63"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe92-fill-1",
    offset: "99.5%",
    stopColor: "#ea8e67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe94-fill",
    x1: 734.285,
    y1: 810.826,
    x2: 738.733,
    y2: 819.602,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe94-fill-0",
    offset: "4%",
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe94-fill-1",
    offset: "99.5%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe102-fill",
    x1: 711.069,
    y1: 644.213,
    x2: 788.068,
    y2: 644.213,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe102-fill-0",
    offset: "0%",
    stopColor: "#313738"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe102-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe106-fill",
    x1: 618.563,
    y1: 765.327,
    x2: 792.425,
    y2: 641.561,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe106-fill-0",
    offset: "0%",
    stopColor: "#313738"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe106-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe107-fill",
    x1: 616.244,
    y1: 991.727,
    x2: 738.846,
    y2: 904.451,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe107-fill-0",
    offset: "0%",
    stopColor: "#313738"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe107-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe108-fill",
    x1: 596.206,
    y1: 995.614,
    x2: 522.485,
    y2: 828.193,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe108-fill-0",
    offset: "0%",
    stopColor: "#313738"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe108-fill-1",
    offset: "100%",
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe125-fill",
    x1: 857.579,
    y1: 575.078,
    x2: 879.06,
    y2: 575.078,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe125-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe125-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "eUaBTMDQpJe126-fill",
    x1: 682.426,
    y1: 673.919,
    x2: 700.08,
    y2: 673.919,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe126-fill-0",
    offset: "13.1%",
    stopColor: "#f05960"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "eUaBTMDQpJe126-fill-1",
    offset: "100%",
    stopColor: "#a31d2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.753167 0 0 0.873566-384.792854-463.344377)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.915598 0 0 1.017896 46.770622-14.504526)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M850.1,743c0,3.3,2.6,5.9,5.9,5.9s5.9-2.6,5.9-5.9c0-3.2-2.6-5.9-5.9-5.9s-5.9,2.7-5.9,5.9Z",
    fill: "#bb7975"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M824.1,690.3c0,0,2.8-8.3,1.5-15.3-1.3-6.9-4.5-18.7-6-22.2-1.6-3.5,2.3-3.7,5.2-1.4s5.4,10.6,8,9.9s5.4-12.2,6.5-16.4s1.1-10.7,4.8-9.2c3.8,1.5.1,21.1,1.4,20.7c1.3-.3,6.2-18.5,9.2-17.9s4.2,2.8,3.1,6.2c-1,3.4-5.6,15.5-4.8,16.5.8.9,9.5-14.8,12.4-12.5c2.9,2.4,1.5,4.5-.9,8.4-1.9,3.1-6.5,10-5.4,10.8.3.4,8-9.5,10.9-6.5c1.4,1.5,1.3,3.1-3.1,7.7-1.7,1.8-6.5,5.8-7.5,7.4-.9,1.7-3.7,7.9-6.9,13-2.6,4.1-10,27.3-10,27.3s-17.5-15.8-18.4-26.5Z",
    fill: "url(#eUaBTMDQpJe10-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.3,682.8c-1.1-6.7-3.7-12.2-10.3-15-2-.8-.9-2.1,1.1-1.3c6.9,2.7,13.2,8.6,12.1,16.3-.2,1.5-2.7,1.5-2.9,0Z",
    fill: "url(#eUaBTMDQpJe11-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M820,653.9c5.1,9,7.7,18.9,8.4,27.4.8,7.9.3,15.1-3.7,23.3l-3.1-5.4l2.4-10l.4.2c4.6-11.3-4.1-35.5-4.4-35.5Z",
    fill: "url(#eUaBTMDQpJe12-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M786.9,892.2q-.7.8-.8,1.3-.6,1.9-.8,3.7c-.3,1.9,7.9,64.7,14.6,88.3h-121.7c-4.6-20-15.4-48.8-18.7-54.8-4.2-7.8-14.8-9-22.5-12.8-5.5-2.7-63.3-31.5-67.1-34.3-21.119143-32.70932-35.1-58.6-56.6-65.9q.1-.3,11.908761-4.72932q0,0,9.591239-4.44c2.2-3.3,44.5-28.33068,51.9-32.73068c2.7-1.7,11.4-7.4,18.5-11.7c3.3-2.1,6.3-3.9,8-4.8q.1,0,.3-.1c10.5-5.1,21.2-8.8,21.2-8.8s-.2.9-.6,2.4c-2.3,10.6-11.6,52.6-13.4,70.3-.3,3.8-.4,6.5.1,7.5q.5.6,1.2,1.1c9,7.5,32.8,12.1,46.2,14.1q2.2.4,3.9.6c3.5.5,5.6.7,5.6.7q0,0,0,0t.1,0q0,0,0,0q.1,0,.2,0t.4,0q.1,0,.3,0q.3,0,.7-.1.2,0,.3,0q.2,0,.4,0q1.1,0,2.6-.1.5-.1,1.1-.1.5,0,1.1-.1.5,0,1.1,0q.7-.1,1.5-.2q1.1,0,2.3-.1.6-.1,1.1-.1q1.1-.1,2.3-.2c11.7-1,29-3.1,48-7q.5-.2,1.1-.3t1.5-.4c2-.7,4.9-1.8,7.6-3.1q1-.5,2-1q.8-.3,1.5-.7c1.2-.6,2.3-1.2,3-1.7q.2-.2.4-.3.3-.2.6-.6c2.6-2.6,4.9-5.9,7-8.9c2.2-3.1,2.7-7.3,5.5-10.1c1.6-1.6,3.9-2.4,5.3-4.2c1.4-1.6,1.9-3.8,2.7-5.9c1.5-4.1,4.1-6.9,7.2-9.9c3.1-2.9,5.2-6.9,7.6-10.4c3.1-4.6,6.2-9,9.1-13.7c2.1-3.2,11.8-41.9,17.1-63.8c2.2-8.8,3.6-14.9,3.6-14.9c5.3,3.5,9.7,9.2,13.8,13.9q2.8,3.1,5.4,6.4c5.2,6.6,17.7,22.7,29.7,63.7c1.5,5.3,3.9,12.9,4.8,19.8",
    fill: "#313738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.7,793c.4,2.8.6,5.5.3,7.9-1.3,12.1-81.9,79.6-91.1,91.3",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M782.8,859.7q-.2.1-.4.1c-.2-.1-.3-.2-.4-.4-7.3-17.4-20-25.3-24.1-27.5q.2-.2.4-.3.3-.2.6-.6c4.7,2.6,17,10.7,24.2,27.9.2.3,0,.7-.3.8Z",
    fill: "#232828"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M660.6,917q-.1,0-.2-.1c-.3-.2-.4-.5-.3-.8c14.9-25.5,8.7-64.9,8.6-65.3-.1-.3.2-.6.5-.7.4,0,.7.2.7.5.1.1,1.7,10.2,1.4,23.3-.2,12-2.2,29.3-10.1,42.8-.1.2-.4.3-.6.3Z",
    fill: "#232828"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M647.7,725.9c.1.9.1,1.8-.1,2.7-.6,1.7-2.1,2.8-3.2,4.2-1.6,2-2.4,4.6-2.2,7.2.2,2.5,1.4,5,3.4,6.7q-2.9.8-5.8,1.7c-.5.1-.9.2-1.4.1-.4-.1-.7-.5-.9-.8-2.5-3.2-2.9-7.8-1.1-11.3.9-1.8,2.3-3.3,3.4-4.9c2.4-3.6,2.7-9.7,2.4-14.1c1,.9,3.4,3.5,4.2,4.5.9.9,1.2,2.7,1.3,4Z",
    fill: "#c1272d"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M534.8,809.2c25-11.4,63.3-30.2,66.6-31.7l8.7-7.4l3.4-10.9c-8.8,4.3-97.3,49.27068-100.2,56.77068c0,.1,8.8-.97068,21.5-6.77068-2.1,30.7,20.23202,38.1,35.1,74.4c22.7,1.1,54.2,23.1,84.8,42-27.5-9.7-50.6-33.55-85.8-42.05-9.345198-26.8-11.910528-49.977114-43.691239-70.33932L534.8,809.2Z",
    fill: "#282828"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M634.4,751.6c0,0,5.8-18.6,6.7-21.4s2.7-7.7,2.2-9.9c-.6-2.2-4.8-12.6-6.3-21.3-1.5-8.8-4.3-19.1-6.4-19.9-2.1-.9-5.2,1.7-5.3,3.2-.1,1.4,4.1,21.1,3.4,21.1-.7-.1-4.8-3.3-6.3-1.9-1.5,1.3-1.9,6.3-4.1,6.9-2.2.5-4.3-.4-4.6,3.2s-.3,3.6-2.5,4.9c-2.3,1.2-1.8,4.1-2.1,8.4s2.6,13.2,2.5,15.3c-.1,1.3-10.2,37.3-10.2,37.3c32.6-15.2,33-25.9,33-25.9Z",
    fill: "url(#eUaBTMDQpJe24-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M641,718.8c0,0,29.1-16.4,31.4-21.1c2.2-4.6,2.9-12.5-6.5-22.8s-13.8-7.4-16.3-4.7-11.2,17.9-14.5,24.9c-3.4,7-6,10.3-6,10.3s4.6,5.5-.3,8.9c0,0,2.1,2,12.2,4.5Z",
    fill: "#f1e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.5,743.6c2.7,5.7,10.6,13.8,16.4,13.7q.5,0,1.1-.2q0,0,.1,0c6.6-2.6,21.7-23.2,21.7-23.2c3.2-6.4,10.1-8.8,10.1-8.8-4.4-.3-6.7-6.2-6.7-6.2-.8,2-3.3,2.2-3.3,2.2-1.8,8.6-9.3,1.2-9.3,1.2-15.2,1.4-26.4,5.7-30.6,7.6q-.8.3-1.2.5c-2.9,1.4-1,7.5,1.7,13.2Z",
    fill: "#f1e6dc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.9,706.4c0,0,9.2,2,15.1,10.3l-3.3,2c0,0-11.4-2.3-11.7-4.1-.3-1.7,2.1-3.4-.1-8.2Z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.8,716.2c5.7,2.4,10.6,7.7,10.9,13.9.1,2.4-.6,4.9-.5,7.3s.9,4.7,2.3,6.6c1.9,2.6,4.7,4.3,7.5,5.9-.7,3.3-1.3,7-2,10.4-3.1-1.3-6.2-2.7-8.5-5.1-4-4.1-4.8-10.3-4.3-15.9.1-2,.5-4,.5-6c.2-5.9-2.3-11.9-6.6-16c.1-.5.2-1,.7-1.1Z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.8,730.4q.4-.2,1.2-.5c1.2-.3,2.7-.1,4.5.8-.6.1-1.2.4-1.7.9-1.6,1.8-1.2,4.9-.7,7c1.6,6.5,8,14.4,14.7,16c.3.1.7-.2.8-.5.7-3.4-1.7-7.3-3.6-9.9-1.7-2.3-4.5-5.7-7.8-5.1-.4,0-.7.3-.7.7.3,1.8,1,3,2,4.4.6.7,1.8-.1,1.2-.8-.7-1-1.3-1.8-1.6-3c4.4.2,9.3,8.4,9.2,12.6-5-1.6-9.3-6.9-11.6-11.4-1-2-1.8-4.4-1.6-6.7.3-3.1,2.3-3.2,4.4-2.2c2.2,1.8,4.7,4.6,7.6,8.8q.9,1.5,1.7,2.7c8.6-7,20.2-15.5,29.6-21.5.6-.4,1.2.5.6.9-9.5,6-20.8,14.7-29.6,21.7c4.2,7.4,3.2,10.6.7,11.8q-.1,0-.1,0-.6.2-1.1.2c-5.8.1-13.7-8-16.4-13.7s-4.6-11.8-1.7-13.2Z",
    fill: "#ddcaba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.2,712.7c4.9-3.6,9.2-6.4,14.2-9.8q7.5-5.1,15-10.2c.6-.4,1.2,0,.6.4-5,3.4-10,7.3-14.9,10.7-5,3.4-9.2,6.5-14.4,9.6-.5.3-.9-.4-.5-.7Z",
    fill: "#ddcaba"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M625.5,718.8c-2.5,3.2-6.5-1.3-7.9-3.3-.7-1.1-2.4-1.6-1.8-.4c1,2.1,3.2,5.4,5.4,6.7-.3.2-.4.6-.4,1c.1,3.3-3.2,1.9-4.7.6-1.2-1-.8-.7-1.6-2-.8-1.2-2-.3-1.5.8c1.1,2.7,3.8,3.4,5.5,4.4c2.6,1.5,5.5-1.1,4.9-4.1c1.5.2,3-.3,4.3-2.1c1-1.4-1.2-3-2.2-1.6Z",
    fill: "url(#eUaBTMDQpJe32-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M622.2,737.8c-.5-.1-.9-.6-.8-1.2c1.2-6.9,6.3-10.2,9.4-11.6-1.5-.9-3.4-2.4-4.7-4.5-1.4-2.3-1.6-4.5-.3-5.7c1.5-1.5,4.3-1.2,7.5.8c3.3,2.1,8.3,2.5,8.3,2.5.6.1,1,.6,1,1.2-.1.6-.6,1-1.2,1-.2,0-5.5-.5-9.2-2.9-2.7-1.7-4.4-1.6-4.9-1.1-.4.4-.3,1.5.6,3c2,3.2,5.9,4.9,5.9,5c.4.1.7.6.6,1c0,.5-.3.9-.8,1-.3.1-9.2,1.8-10.7,10.2-.1.6,0,1.4-.6,1.3q0,0-.1,0Z",
    fill: "url(#eUaBTMDQpJe34-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M630,704.4c-.7-1.3-1.8-.9-1.2.6.5,1.2,2,6.3.5,7.2-1.8,1.1-5-.7-6.1-2s-3.2-.5-2.1.9c2,2.4,6.4,5.2,9.6,3.5c3.7-1.8.8-7.7-.7-10.2Z",
    fill: "url(#eUaBTMDQpJe36-fill)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M741.2,839.1q.5-.2,1.1-.3q0,0,0,0q.9,3,1.7,6c2.4,9.5,4.3,19.1,4.8,28.9.1,2.3.2,4.6.3,6.9s.2,4.6.3,6.9c.1,4.3,0,8.7-.9,13q-.9-.7-1.7-1.4c-5.9-4.9-11.3-10.3-16.8-15.5-2.8-2.7-5.6-5.2-8.4-7.9q-4.3-4.1-8.6-8.2-8.7-8.3-17.3-16.7-2.2-2.3-4.5-4.5.6-.1,1.2-.1.4-.1.8-.1c11.6-1,28.6-3,47.2-6.9q.4-.1.8-.1Z",
    fill: "#1a1a1a"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M739.4,840.1q.4-.1.9-.2q0,0,0,0q.8,2.5,1.4,5.1c2.2,8.1,3.7,16.4,4.2,24.7.1,2,.1,4,.2,5.9q.2,3,.3,6c.1,3.7,0,7.4-.8,11.1q-.7-.6-1.4-1.2c-5.1-4.2-9.7-8.8-14.4-13.3-2.4-2.3-4.8-4.5-7.2-6.7q-3.7-3.5-7.4-7.1-7.4-7.1-14.7-14.3-2-1.9-3.9-3.8.5-.1,1-.1.4-.1.7-.1c9.9-.9,24.5-2.6,40.4-5.9q.3,0,.7-.1Z",
    fill: "url(#eUaBTMDQpJe40-fill)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.2 0 0 1.2-145.479565-169.82932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M707.1,794.2q0-.1-.1-.1q0-.1-.1-.1-.3-.5-.8-.9-.4-.4-.8-.9-.4-.3-.8-.7t-.9-.7q-.9-.7-2-1.2-1-.4-2.2-.6c-1.6-.1-2.9.6-3.9,1.7-.9,1.1-1.4,2.6-1.4,4.1-.1,2.8,1.6,6,4.1,8c2.4,2.1,5.6,3,8.5,1.4q.5-.3.9-.7.5-.5.7-1.1.5-.9.6-1.9.1-1.1-.1-2.1-.1-1.2-.5-2.2-.5-1.1-1.2-2Z",
    fill: "url(#eUaBTMDQpJe43-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.9,793.3q-.1.8-.1,1.6-.1.8-.1,1.6c0,1.5.2,3.1.4,4.6s.6,3,.9,4.4c.5,2.1.3,4-.2,5.8-.4,1.9-1.2,3.7-2.1,5.5q-1,2.1-2.2,4.2-1.1,2-2.5,3.9-.7,1-1.4,2-.7.9-1.5,1.8c-.3.5-.7,1-1.1,1.4-.4.5-.9.9-1.4,1.2q-.3.2-.6.4-.3.1-.7.2-.3.2-.7.3-.3.1-.7.2q0,0-.1,0q0,0,0,0l-.3.1h-.3q-.6.1-1.2.2-.6,0-1.2.1c-.4,0-1,0-1.5,0s-.9,0-.9,0l-.1.3v.2q0,.2,0,.3q0,.2,0,.3q0,.8,0,1.5t0,1.4q.1.9.2,1.7.1.9.2,1.7c0,.3.2,1.5.5,2.8.3,1.4.7,2.9,1,3.9.4.9.8,1.8,1.1,2.4s.5.9.5.9-.1.2-.3.4c-.3.3-.5.6-.7.7-1.6,1.4-3.6,2.4-5.7,3.2-2.1.7-4.3,1.2-6.4,1.5-2.4.5-4.7.7-7,.6s-4.6-.5-6.9-1.2q-1.8-.6-3.4-1.4-1.7-.8-3.2-1.9-.8-.5-1.5-1.1t-1.4-1.3c-.3-.3-.9-.9-1.3-1.6-.5-.6-.9-1.3-1-1.7.3-.4.6-.6.9-.9s.6-.6.8-1q1.5-3,2.7-6.1q1.3-3,2.1-6.2.2-.6.3-1.2.2-.6.3-1.2c.5-2.5.7-5,.8-7.6.1-2.5,0-5-.1-7.6q-.2-3.9-.5-7.8-.3-3.8-.7-7.7q0-.4-.1-.8q0-.4,0-.9-.3-2.7-.6-5.4-.2-2.7-.6-5.4c-.3-1.8-.6-3.5-.9-5.3-.3-1.7-.6-3.5-.6-5.3v-.3-.3c0-1,.1-1.7.4-2.4.3-.6.8-1.2,1.5-2q.2-.3.5-.5.3-.3.5-.5.7-.6,1.4-1.2.8-.5,1.6-.9.5-.3,1.1-.6.5-.2,1.1-.4.3-.2.6-.2.3-.1.5-.2.3-.1.5-.2.2,0,.4-.1.3-.1.7-.2.4,0,.8-.1c1.9-.3,3.7-.7,5.6-1c1.8-.3,3.7-.5,5.6-.5q3.7-.1,7.4,0t7.5.2q.6.1,1.4.1.7,0,1.5,0q.3,0,.6,0t.5,0q.3,0,.5,0t.4,0q.2.1.4.1t.4,0q.4.1.8.2.3,0,.7.1.9.3,1.6.7.7.5,1.3,1.2.2.3.4.6.2.4.5.7c1.1,1.9,2,4,2.7,6.2.7,2.1,1.2,4.4,1.5,6.4q.1,1.4,0,2.7-.1,1.4-.3,2.7c-.2,1.2-.5,2.3-.7,3.5-.3,1.2-.6,2.3-.8,3.5Z",
    fill: "#ffb88c"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M752.3,768c-.4.3-1,.5-1.5.8-.5.2-.9.4-1.2.6q-1.2.7-2.6,1.2t-2.8,1q-2.6.7-5.3,1.2-2.6.5-5.3.8c-1.7.2-3.4.2-5.1.2-1.8.1-3.5,0-5.2,0-.7,0-1.5,0-2.3,0-.8.1-1.6.2-2.2.4-.8.4-1.3,1-1.7,1.8-.4.7-.6,1.6-.9,2.4-.7,1.7-1,3.5-1.2,5.4-.2,1.8-.2,3.7-.3,5.5q-.1,3.1-.1,6.2t.4,6.1c.6,4.5,1.4,8.8,2.9,12.9c1.5,4,3.8,7.7,7.3,10.9q.7.6,1.4,1.1.7.6,1.5,1q2.3,1.5,4.9,2.5t5.4,1.6c.6.1,1.5.1,2.3.1s1.5-.1,1.5-.1q-.3.1-.6.2-.3.2-.9.3q0,0,0,0-.1,0-.1,0h-.3l-.2.1q-.6.1-1.2.2-.7,0-1.3,0c-.4,0-1,.1-1.5.1s-.9,0-.9,0l-.1.2v.1q-.2,0-.3,0-.2,0-.3.1-.3.1-.6.2t-.6.2c0,0-.2,0-.3.1-.2,0-.3.1-.3.2-.1.5-.9.8-1.8,1-.8.3-1.7.5-1.7,1c.1.6-.9.6-1.8.6s-1.9,0-1.8.6c-2.1.8-3.2,1.5-4.2,1.9-1.1.5-2.3.7-4.6.9-1.5.1-3,.4-4.6.6-1.5.2-3,.3-4.5-.1q-.6-.1-1.1-.3t-1-.4c-.2-.1-.5-.1-.7-.2-.3-.2-.5-.3-.6-.5s.1-.6.2-.9c.2-.4.4-.8.5-1q.3-1,.7-2q.3-1,.6-2.1.5-2.1.9-4.2.3-2.2.5-4.4q0-.8,0-1.6.1-.8.1-1.6q0-2.9-.1-5.7-.1-2.9-.3-5.7c-.1-1.8-.3-3.6-.5-5.4-.1-1.8-.3-3.6-.4-5.4q0-.4-.1-.8q0-.4,0-.8-.3-2.7-.6-5.4-.3-2.8-.6-5.4c-.3-1.8-.6-3.6-.9-5.3-.3-1.8-.6-3.6-.6-5.4v-.3-.3c-.1-1,.1-1.7.4-2.3.3-.7.8-1.3,1.5-2q.2-.3.5-.6.2-.2.5-.5.6-.6,1.4-1.1.7-.5,1.5-1q.6-.3,1.1-.5.6-.3,1.1-.5.3-.1.6-.2t.6-.2q.2,0,.4-.1t.4-.1q.4-.1.7-.2.4-.1.9-.2c1.8-.3,3.7-.6,5.6-.9c1.8-.3,3.7-.6,5.6-.6q3.7,0,7.4,0q3.7.1,7.4.3.7,0,1.4,0q.8,0,1.6,0q.2,0,.5,0t.6,0q.2,0,.4.1.2,0,.5,0q.2,0,.4,0t.3.1q.4.1.8.1.4.1.7.2.9.2,1.6.7.8.4,1.3,1.1.2.4.4.7.3.3.5.7Z",
    transform: "translate(-.811116 0.842938)",
    fill: "url(#eUaBTMDQpJe46-fill)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M731.1,788.3c.4,1.2.8,2.6,1.1,4c.2,1.3.3,2.7,0,4q-.1.6-.3,1.1-.2.4-.5.9c-.4.6-1.1.9-1.7,1.2-.7.2-1.4.4-2.1.7q-.6.2-1.2.5-.6.2-1.3.4c-2.3.5-4.6-.2-6.5-1.5-1.9-1.4-3.3-3.3-3.9-5.3-.3-1-.6-2.7-.5-4.3.2-1.6.9-2.9,2.6-3.1q.5-.1,1-.2t1-.1q1,0,2,.1t2,.4q1.1.3,2.3.6q1.1.4,2.3.7.4.1.8.1t.9-.2c.2-.1.5-.4.8-.5.3-.2.6-.3.8-.2s.3.2.3.3c.1.2.1.3.1.4Z",
    fill: "url(#eUaBTMDQpJe48-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M732.1,797.2c-.1.6-.3,1-.7,1.4-.3.4-.8.7-1.2,1q0,0-.1,0q0,0,0,.1q0,0-.1,0-.2.1-.3.2-.7.3-1.4.5t-1.5.3q0,0-.1,0-.2,0-.3,0-.4,0-.9,0-.5.1-1,.1-.4,0-.8-.1-.4,0-.8-.1-.7-.1-1.3-.5t-1.1-1q0,0,0,0t-.1,0c-.5-.6-.9-1.4-1.3-2.2-.3-.8-.5-1.7-.7-2.5q0-.1,0-.3t0-.3c-.1-.5,0-1,.1-1.4.2-.4.5-.7.9-.9q.9-.4,1.8-.6q1-.1,1.9-.2c1.5,0,3,0,4.3.4c1.4.5,2.6,1.2,3.4,2.6q.3.4.6.9.2.5.4,1.1.1.2.1.5.1.3.1.6q0,.1.1.2q0,.1,0,.2Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.2,785.9q0,.1,0,.1t0,0c-.2,1.2-.4,2.3-.7,3.5-.3,1.1-.5,2.3-.7,3.5q-.1.7-.2,1.5-.1.9-.3,1.6c0,0-.2,0-.3,0s-.3,0-.3,0s0,.1,0,.2s0,.1,0,.2c-.6.8-1.2,1.6-1.8,2.1-.7.6-1.5,1-2.5,1.1-.6,0-1.3,0-1.9-.2s-1.1-.5-1.5-1q-.5-.7-.8-1.5-.2-.9-.2-1.7c-.1-1.3.1-2.8.5-4.1.4-1.4,1-2.7,1.8-3.7q.1-.1.3-.2.2,0,.3-.1.9-.4,1.9-.8q1-.3,2-.5c.6-.2,1.4-.4,2.2-.4.8-.1,1.6,0,2.2.4Z",
    fill: "url(#eUaBTMDQpJe51-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M754.5,793.5q0,.2,0,.5q0,.2,0,.4q0,.1,0,.3q0,.1-.1.3q0,.6-.1,1.1-.1.6-.3,1.1q0,0-.1.1q0,0,0,.1c-.2.4-.5.7-.9,1-.3.3-.7.5-1.2.7q-.1,0-.1,0-.1.1-.2.1-.2.1-.5.2t-.6.2c-.6.2-1.4.4-2.1.4-.7-.1-1.4-.2-1.9-.6q-.2-.2-.4-.4t-.3-.4q0-.1,0-.1q0-.1-.1-.1-.2-.5-.2-1.1-.1-.6,0-1.2.2-.9.5-1.6.4-.8.8-1.5c.6-.9,1.5-1.5,2.6-2c1-.4,2.1-.7,3.2-.7.4,0,.7,0,1.1.1.3.1.5.3.6.7q.1.4.2.7q0,.3.1.6q0,.2,0,.5t0,.6Z",
    fill: "#b74e39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.1,809.5q.7.2,1.4.4.7.1,1.5.1.7,0,1.4-.1.7,0,1.3-.2.4-.1.7-.2t.6-.2q.1-.1.2-.1t.2.2q0,.1,0,.2t0,.2q0-.1,0-.2q0-.2,0-.3c-.1-.2-.2-.5-.3-.6-.2-.2-.3-.3-.4-.3-.4.2-.8.4-1.2.5-.3.1-.7.1-.8.2q-1,.2-1.9.2t-1.8-.1c-.3,0-.9-.1-1.5-.2-.6-.2-1.2-.3-1.7-.6q.2.2.5.3.2.2.4.3.3.1.7.3.3.1.7.2Z",
    fill: "#ffe5d7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.4,809.4q-.1-.2-.2-.2t-.2.1q-.3.1-.6.2t-.7.2q-.6.2-1.3.2-.7.1-1.4.1-.8,0-1.5-.1-.7-.2-1.4-.4-.4-.1-.7-.2-.4-.2-.7-.3-.2-.1-.4-.3-.3-.1-.5-.3q0-.1-.1-.1-.1-.1-.1-.1-.2.1-.4.2t-.3.2q-.4.3-.9.6-.4.3-.8.7-.3.3-.3.6t.1.7q.1.2.2.4q0,.2.1.4t.2.3q.1.2.3.3.1,0,.2,0t.2,0t.3,0q.2-.1.3-.1.2,0,.3,0q.2-.1.3-.1.8-.1,1.6.1.8.1,1.6.4.7.2,1.4.2.7.1,1.4.1.8.1,1.5-.1.6-.2,1.2-.7.5-.5.9-1.1.3-.6.4-1.3q0-.1,0-.1t0-.1t0-.2t0-.2Z",
    fill: "url(#eUaBTMDQpJe54-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.2,832.5c0,0,0,.3,0,.5-.1.3-.1.5-.1.5c0-.1-.2.1-.4.3-.3.3-.6.5-.6.6q-.5.3-1.1.7-.5.3-1,.6-1,.6-2.1,1.2t-2.2,1.2q-2.1,1.1-4.4,2-2.2.9-4.5,1.7-3.6,1.3-7.3,2.4-3.6,1.1-7.4,1.8-.5.1-.9.2-.5.1-.9.2c-.2,0-.8,0-1.3-.1s-1-.1-1.2-.2c0,0,.3-.4.5-.8.3-.4.6-.9.8-1.2q.9-1.6,1.6-3.2.8-1.6,1.4-3.3q1.4-3.4,2.2-7q.8-3.5,1-7.2q0-.1,0-.2.1,0,.1-.1.1-1.2.1-2.4t0-2.3q0-2.5-.1-4.9t-.2-4.7q-.1-.7-.1-1.3-.1-.7-.1-1.4-.2-1.8-.3-3.6-.2-1.8-.3-3.6q0,0,0-.1q0,0,0,0c.3-.5.5-1,.8-1.5.2-.5.5-.9.8-1.2q.7,2.4,1.2,4.9t.8,5q.3,2.3.8,4.7.4,2.3.8,4.6c.2,1.2.4,2.4.8,3.6.4,1.1.9,2.2,1.8,3.1q.6.5,1.2,1q.7.5,1.3.9q1.9,1.3,3.7,2.4q1.9,1.2,3.8,2.2q1.3.7,2.7,1.3q1.4.7,2.8,1.2.7.3,1.4.5t1.5.4c.3.1.7.2,1.2.3.4.1.9.2,1.4.3Z",
    fill: "url(#eUaBTMDQpJe55-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.5,810.6q-.2.5-.5,1-.3.4-.8.8-.2.2-.5.4t-.6.2q.2-.1.3-.1.1-.1.1-.2.3-.1.5-.3t.3-.4q.2-.2.4-.5.2-.2.3-.4.2-.4.3-.7.1-.4.1-.8-.1-.2-.1-.3-.1-.2-.1-.3-.2-.2-.4-.4t-.4-.4q-.1-.1-.3-.3-.1-.2-.3-.4c-.2-.2-.5-.6-.7-1s-.4-.8-.5-1.1c-.2-.4-.4-.8-.5-1.1-.1-.4-.2-.7-.3-1.2q-.6-1.8-.7-3.7-.2-1.8.2-3.7.2-1.3.6-2.5.5-1.3,1.1-2.4.2-.2.3-.4.1-.3.3-.5.1-.2.3-.3.1-.1.3-.3q0,0,0,0t.1,0q0,0,0,.1q0,0-.1,0-.6.9-1.1,1.8-.5,1-.8,1.9-.2.6-.3,1.1-.2.5-.3,1.1-.3,1.6-.3,3.3.1,1.8.4,3.4c.1.4.3,1,.4,1.5.2.5.4,1,.5,1.4.3.6.5,1.1.7,1.6.3.4.6.9,1,1.3q.2.2.4.4t.3.3q.2.1.3.3.1.1.1.3.2.4.1.8q0,.3-.1.7Z",
    fill: "url(#eUaBTMDQpJe56-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.8,760.9q-1.2-.6-2.4-1t-2.5-.6c-1-.3-2-.3-2.9-.3s-1.9,0-2.9.1c1.4-1.5,3.1-2.8,4.8-3.9c1.8-1.1,3.7-1.9,5.7-2.4-.4-1-1.4-1.9-2.5-2.7s-2.4-1.4-3.3-1.8q-4-1.9-8.3-2.4-4.2-.5-8.7.1-2.4.4-4.7,1.1t-4.5,1.8q-1.3.6-2.6,1.4-1.2.7-2.5,1.4c-.7.5-1.4,1-2.1,1.6-.7.5-1.4,1-2.1,1.5-.6-.8-1.6-1.4-2.7-1.9-1-.4-2.2-.7-3.1-.8q-1.3-.1-2.5.1t-2.3.5c-.5.2-1.4.5-2.1.8-.8.4-1.5.9-1.6,1.5c1.8-.4,3.7-.1,5.3.6c1.6.8,2.9,2.1,3.6,3.9-1.3-.1-2.7,0-4,.4-1.4.3-2.6.8-3.8,1.4q-.8.4-1.4.9-.7.4-1.4,1c-.3.3-.7.6-1.1,1.1-.4.4-.7.8-.8,1.3c1-.3,2.1-.1,3,.5.9.5,1.7,1.3,2.2,2.2.5.8.9,1.7,1.2,2.6.2.8.5,1.7.7,2.7q.3,1.4.7,2.8.5,1.4.8,2.8.6,2.6,1.1,5.2.5,2.5.9,5.1.4,1.9.7,3.7.3,1.9.5,3.7.1,1,.2,1.9q0,.8.1,1.8c.1.9.2,1.5.2,2.2.1.6.1,1.3.2,2.1-.1-.1.1-.3.3-.4.3-.1.5-.3.6-.3q.2-.1.4-.3.3-.1.5-.2c.1,0,.3-.1.5-.2s.4-.1.4-.2q-.1-.7-.2-1.5-.2-.7-.3-1.5-.1-.7-.2-1.4q0-.8-.1-1.5-.1-.3-.1-.6t-.1-.6q0-.3,0-.5q0-.3-.1-.6-.4-3.9-.5-7.8-.1-3.8.1-7.7q0-.6.1-1.2q0-.6.1-1.1q0-.1,0-.2.1-.1.1-.1.1-.1.1-.1.1-.1.1-.1.4-.2.8-.4t.8-.3c.1,0,.4-.1.7-.2s.5-.2.6-.4q0,0,.1,0q0-.1,0-.1q0-.8,0-1.6t-.1-1.5q0-.5,0-.9q0-.5,0-1-.1-.2-.1-.5t0-.6q0,0,0-.1q0,0,0-.1q0-.2,0-.5-.1-.2,0-.4c1.2.4,2.5.7,3.9,1c1.4.2,2.8.3,4.1.3c2.9.2,5.8.6,8.8.8c2.9.2,5.9.3,8.8,0q2.2-.3,4.3-.6q2.2-.4,4.3-.9c1.3-.3,2.6-.8,3.8-1.3c1.2-.4,2.3-1,3.6-1.4c1.2-.2,2.6.2,4.1.8c1.4.6,2.7,1.4,3.6,2-.7-1.7-1.6-3.3-2.8-4.7-1.1-1.3-2.4-2.5-4.1-3.3Z",
    fill: "#010019"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M746.1,786.1c.3.3.8.2,1.3,0c.5-.1,1-.4,1.3-.6q.8-.5,1.5-.9.8-.4,1.6-.8q1-.4,2-.6q1.1-.3,2.2-.4.2,0,.5,0q.3.1.5.3c.1.1.2.3.2.6.1.2.1.5.1.7q.1.3.1.7-.1.4-.2.8-.1.3-.3.5-.2.3-.4.5-.1,0-.1.1-.1.1-.2.1-.2.2-.4.2-.2.1-.4.2-.3.1-.6.1-.3.1-.6.2-.4.1-.7.2t-.7.3q-1.2.4-2.3.8-1.2.4-2.4.8c-.4.1-.8.2-1.2.2-.3,0-.7-.1-1-.4q-.1-.1-.2-.3t-.1-.4c-.1-.5-.1-1,0-1.5s.3-1,.5-1.4Z",
    fill: "url(#eUaBTMDQpJe58-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.8,786.1c.1.1-.3.2-.6.3-.4,0-.8,0-.9,0-.3,0-.9,0-1.4-.1-.6-.1-1.1-.1-1.5-.2q-.9-.3-1.7-.5-.8-.1-1.5-.2c-1.3-.2-2.3-.4-3.3-.5-.9-.1-1.9-.2-3.2-.3q-.5,0-1,0-.4,0-.9.1-.4.1-.7.3t-.6.4q-.4.2-.7.6-.3.3-.6.6-.7.7-1,1.6-.4,1-.3,1.9c0,.2.2.1.4,0c.3-.2.5-.4.6-.4.6-.3,1.3-.5,2-.6s1.5-.1,2.2-.2q1.2,0,2.4.1q1.2,0,2.4.2c.9.1,1.5.2,2.2.3.6.1,1.2.2,2.1.4.5,0,1.1.2,1.6.2.5.1,1,.2,1.4.2q.5-.1.9-.2.5-.2.9-.5.3-.3.4-.6.2-.2.3-.6c.1-.3.2-.7.2-1.1.1-.5.1-.9-.1-1.2Z",
    fill: "url(#eUaBTMDQpJe59-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.2,802.3c-.3.1-.7.1-1.1.1-.4-.1-.8-.2-1.1-.3q-.6-.2-1.1-.5-.5-.2-.9-.6c-.5-.4-.9-1-1.2-1.7-.3-.6-.5-1.3-.6-2q0-.5.1-.9.1-.5.4-.9c.2-.3.5-.7.9-.9.4-.3.8-.5,1.1-.6q1.2-.3,2.1,0q1,.3,1.8,1.2.3.3.5.6.3.3.5.6q0,.1.1.1q0,.1,0,.1.1.2.2.3q0,.1.1.3c-.3-.4-.6-.7-1.1-.9-.4-.2-.8-.3-1.2-.3q-.4.1-.7.2t-.6.4c-.5.6-.6,1.3-.5,2.1c0,.7.3,1.4.7,2q.3.6.7.9.4.4.9.7Z",
    fill: "#910f2e"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M736.1,809.1q-.1.1-.3.2t-.3.2-.3.2q-.1.1-.2.2-.3.3-.3.6q0,.4.1.7.2.4.3.7.2.3.5.6c0,0-.1-.2-.2-.4-.1-.3-.2-.6-.3-.9q-.1-.1-.1-.4t0-.5q.1-.1.2-.2t.3-.2q.3-.2.6-.5.3-.2.6-.4.1-.1.3-.2.1-.1.2-.2c.1,0,.2-.2.3-.3s.2-.2.1-.1q-.4.2-.7.4-.4.3-.8.5Z",
    fill: "#cc5e48"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M741.3,813.2c0-.1-.1-.2-.2-.3s-.3-.2-.3-.3q-.3-.1-.5-.2t-.5-.2q-.5-.2-1-.3t-1,0q-.3.1-.3.2-.1.1,0,.4.1.1.3.2t.4.2q.4.1.8.1.3,0,.7,0t.8,0q.4.1.8.2Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.1,797.5v.1.1c-.1.6-.3,1-.7,1.4-.3.4-.8.7-1.2,1q0,0-.1,0q0,.1,0,.1t-.1,0q-.2.1-.3.2-.7.3-1.4.5t-1.5.3q0,0-.1,0-.2,0-.3,0-.3,0-.7,0-.3.1-.7,0-.1.1-.2.1t-.2,0h-.1q-.4,0-.8-.1-.4,0-.8-.1-.3,0-.6-.1-.2-.1-.5-.3-.6-.3-1-.7-.4-.5-.8-1-.2-.3-.3-.6-.2-.2-.3-.5t-.3-.6q-.1-.3-.2-.6-.2-.5-.3-.9t-.2-.8q0-.2,0-.4t0-.3c-.1-.5,0-.9.1-1.3.2-.4.5-.8.9-1q.9-.4,1.8-.6q1-.1,1.9-.1c1.5-.1,3-.1,4.3.4c1.4.4,2.6,1.1,3.4,2.5q.3.5.6,1q.2.5.4,1q.1.3.1.6.1.2.1.5q0,.1.1.1q0,.1,0,.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732.1,797.5q-1.3-.4-2.5-.7t-2.5-.4q-.7-.1-1.5-.1-.7-.1-1.4-.1-.3,0-.5,0-.3,0-.6,0-1.1.1-2.1.2-1.1.1-2.1.3-.2-.5-.3-.9t-.2-.8q0-.2,0-.4t0-.3c-.1-.5,0-.9.1-1.3.2-.4.5-.8.9-1q.9-.4,1.8-.6q1-.1,1.9-.1c1.5-.1,3-.1,4.3.4c1.4.4,2.6,1.1,3.4,2.5q.3.5.6,1q.2.5.4,1q.1.3.1.6.1.2.1.5q0,.1.1.1q0,.1,0,.1Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.5,794.1q0,.1,0,.2q0,0,0,.1q0,.3-.1.6q0,.3,0,.6l-.1.2v.1.1c0,0,0,.1,0,.3-.1.1-.1.3-.1.4q0,.1-.1.3q0,.1,0,.3-.1.3-.2.6-.1.2-.3.5-.3.4-.8.7t-1,.5q-.1.1-.1.1-.1,0-.2.1-.1,0-.1,0-.1.1-.2.1q0,0-.1,0q0,0,0,.1-.2,0-.3.1-.2,0-.3.1q0,0,0,0t-.1,0q0,0,0,0-.1,0-.1,0-.1,0-.3.1-.1,0-.3,0-.1.1-.2.1-.2,0-.3,0q0,0-.1.1-.1,0-.1,0-.1,0-.2,0t-.2,0q-.6,0-1.2-.1t-1-.5q-.2-.1-.3-.2t-.2-.2q0-.1,0-.1t0-.1q-.1,0-.1-.1q0,0,0-.1-.1,0-.1,0t0-.1-.1-.2c0-.1,0-.2,0-.2q-.2-.5-.2-.9-.1-.5,0-1t.3-.9q.1-.5.3-.9.1-.2.1-.3.1-.1.2-.3q0,0,0-.1.1,0,.1-.1q0,0,.1-.1q0-.1.1-.2q0,0,.1-.1q0,0,0-.1.1,0,.1,0q0-.1,0-.1t.1-.1q0,0,0,0q.1-.1.1-.2.1,0,.1-.1c.7-.7,1.6-1.3,2.5-1.6.9-.4,1.9-.6,2.9-.7.4,0,.7,0,1.1.2.3.1.5.3.6.7q.1.1.1.2t0,.2q.1.2.1.4t.1.4q0,.3,0,.6t0,.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.5,794.1q0,.1,0,.2t0,.1q0,.4-.1.7q0,.3,0,.6l-.1.1v.2q-.3,0-.7.1-.3,0-.7.1-.9.2-1.8.3-.8.2-1.7.5-.4.1-.8.3-.4.1-.8.3-.6.2-1.1.5-.6.3-1.1.7-.2-.5-.3-1.1q0-.5.1-1q.1-.7.4-1.3.3-.7.6-1.2q1.1-.8,2.4-1.2q1.2-.5,2.5-.7.7-.1,1.5-.2.7-.1,1.5,0q.1.2.1.4t.1.4q0,.3,0,.6t0,.6Z",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704.6,745.5c1.2.3,2.1.6,2.9,1s1.4.9,2.2,1.7c.7.7,1.3,1.5,1.8,2.4s.8,1.8.8,2.8c-.1-.4-.4-.9-.7-1.3s-.7-.9-.9-1.2q-.4-.7-.9-1.2-.5-.6-1-1.1-.9-1.1-1.9-1.8-1.1-.8-2.3-1.3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.2,792.1c0-1.3.9-2,2-2.2s2.4,0,3.2.6q.4.3.8.5.3.3.6.7c.2.2.3.5.3.8s-.1.5-.4.7c-.2.1-.5,0-.9,0-.3,0-.6-.1-.8-.1q-.5,0-1,.1t-1,.2q-.5.2-.9.2t-.9-.2c-.2-.1-.5-.3-.7-.5-.2-.3-.3-.5-.3-.8Z",
    fill: "url(#eUaBTMDQpJe69-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,797.2c-.3-.4-.6-.7-1.1-.9-.4-.2-.8-.3-1.2-.3-.4-.1-.8,0-1.2.2-.3.3-.6.6-.8.9q-.3.5-.5,1.2-.1.6,0,1.2c0,.3.1.8.3,1.2.1.4.4.8.7,1-.6-.2-1.1-.5-1.6-1-.5-.4-.9-.9-1.2-1.4q-.4-.6-.5-1.4-.1-.7.1-1.4.2-.9.8-1.4t1.5-.6c.9-.1,1.7,0,2.4.4.7.3,1.3.9,1.9,1.5q0,.1.1.1q0,.1,0,.1.1.2.2.3q0,.1.1.3Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M720.9,751.2q0,.2,0,.4.1.1.3.3.3.4.6.7.4.4.8.6.8.5,1.6.8t1.7.5q.4.2.8.3.4,0,.9,0q.3-.1.6-.2.3-.2.7-.4q1.4-.6,2.9-1.3q1.5-.6,3-1q1.5-.5,3.1-.7q1.6-.1,3.2.1c-1.6,0-3.3.3-4.8.9-1.6.5-3.1,1.3-4.4,2.3q-.1.1-.3.2-.1.2-.2.3c-.2.7.5.9,1.2,1c.8.1,1.6,0,1.9-.1q1-.2,1.9-.5.9-.4,1.8-.7c1.7-.7,3.5-1.2,5.2-1.7c1.8-.5,3.6-.8,5.4-.9-.1,0-.3-.1-.4-.2-.2,0-.4-.1-.5-.2q-.3-.1-.6-.1-.3-.1-.6-.2-.6-.2-1.2-.3t-1.2-.2q-2-.3-4.1-.6-2-.2-4-.2q1.3-.3,2.6-.4q1.4-.1,2.7-.1.7,0,1.4,0q.6.1,1.3.1.2,0,.4,0q.1.1.3.1.1,0,.3,0t.3,0c.2-.1.2-.1.1-.2s-.2-.2-.3-.2q-.3-.2-.6-.3t-.6-.3q-.6-.2-1.2-.4-.7-.2-1.3-.3-.8-.1-1.5-.3-.7-.1-1.5-.2c-1.5-.1-3-.3-4.5-.3-1.6,0-3.1.1-4.6.4q-2.1.5-4.1,1.2-2,.8-3.9,1.8-.2.2-.4.3-.1.1-.2.2Z",
    fill: "url(#eUaBTMDQpJe72-fill)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M730.1,800.2c0,0-.5.2-1.2.5-.6.3-1.5.6-2.3.7-.6,0-1.2.1-1.9,0-.6,0-1.2,0-1.8-.1q-.7-.2-1.3-.6t-1-.9c.5.2,1,.3,1.4.4.5.1.8.2,1,.2q1.2.2,2.3.2t2.3-.1c.4,0,1-.1,1.5-.2.5,0,.9-.1,1-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M747.7,800.5q.8,0,1.6-.1.8-.2,1.6-.4c.5-.2,1-.4,1.5-.7.6-.3,1-.7,1.4-1.1q-.3.4-.5.8-.3.3-.6.6t-.7.5q-.5.2-.9.3t-.9.2q-.6.1-1,.1-.4-.1-.8-.1-.3-.1-.7-.1Z",
    fill: "#ea8e67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.8,796.3c0,1.1-.5,2.2-1.2,3-.8.7-1.9,1.2-3,1.2-1.2,0-2.3-.5-3-1.2-.8-.8-1.3-1.9-1.3-3c0-1.2.5-2.3,1.3-3c.7-.8,1.8-1.3,3-1.3c1.1,0,2.2.5,3,1.3.7.7,1.2,1.8,1.2,3Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5,796.3c0,1-.4,2-1.1,2.7-.8.8-1.7,1.2-2.8,1.2s-2.1-.4-2.8-1.2c-.7-.7-1.2-1.7-1.2-2.7c0-1.1.5-2.1,1.2-2.8s1.7-1.2,2.8-1.2s2,.5,2.8,1.2c.7.7,1.1,1.7,1.1,2.8Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5,796.3q0,0,0,0q0,.1,0,.1c-.1,0-.6,0-1.3-.1-.7,0-1.5-.1-2-.1q-.3,0-.5,0-.3-.1-.6,0-.9,0-1.7.1-.9.1-1.8.3q0-.1,0-.2t0-.2c0-1.1.5-2,1.2-2.7s1.7-1.2,2.8-1.2s2.1.5,2.8,1.2s1.1,1.7,1.1,2.8Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.1,796.3c0,.6-.3,1.3-.8,1.7-.4.5-1,.7-1.7.7s-1.3-.2-1.8-.7c-.4-.4-.7-1.1-.7-1.7c0-.7.3-1.4.7-1.8.5-.5,1.1-.7,1.8-.7s1.3.2,1.7.7c.5.4.8,1.1.8,1.8Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M731.8,796.1q.2.7.2,1t0,.3c0-.1-.5-.7-1-1.2s-1.1-1-1.3-1.1c-.3-.1-.5-.3-.8-.5s-.5-.4-.8-.4q-.8-.2-1.6-.3-.7-.1-1.6-.1t-1.7.1q-.9.1-1.8.1-.7.1-1.5.2t-1.5.1c-.1-.5,0-.9.1-1.3.2-.4.5-.8.9-1q.9-.4,1.8-.6q1-.1,1.9-.1c1.5-.1,3-.1,4.3.4c1.4.4,2.6,1.1,3.4,2.5q.3.5.6.9.2.5.4,1Z",
    fill: "url(#eUaBTMDQpJe79-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M732,797.4c0,0-.1-.2-.2-.3-.2-.1-.4-.3-.4-.4q-.4-.3-.7-.5t-.4-.3c-.2-.1-.4-.2-.6-.3-.1-.1-.3-.2-.5-.3q-.8-.2-1.6-.4-.8-.1-1.6-.2-.6,0-1.2,0-.6-.1-1.2,0-.6,0-1.3.1-.6,0-1.3.1-.6.1-1.3.1-.6,0-1.2-.1c-.5-.1-.8-.3-1-.7-.2-.3-.4-.7-.5-1.1.1.1.3.2.5.2s.4,0,.6,0q.4.1.8.1t.8-.1q1.1,0,2.2,0q1,.1,2.1.1c1,0,2.1.2,3.2.4c1.1.3,2.1.7,2.9,1.4q.3.2.6.4.3.3.5.6c.1.1.3.4.5.6.2.3.3.6.3.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M752,796.6c0,1.1-.4,2-1.1,2.7-.6.6-1.6,1.1-2.6,1.1q-.7,0-1.3-.3-.6-.2-1.1-.6q0-.1-.1-.3t-.2-.5c0-.2-.1-.6-.2-.9c0-.4,0-.8,0-1.1q.1-.5.3-.9.1-.5.3-.9.1-.2.1-.3.1-.1.2-.3q0,0,0-.1.1,0,.1-.1q0,0,.1-.1q0-.1.1-.2q0,0,.1-.1q0,0,0-.1.1,0,.1,0q0-.1,0-.1t.1-.1q0,0,0,0q.1-.1.1-.2.1,0,.1-.1.3-.1.6-.2.3,0,.6,0c1,0,2,.4,2.6,1.1.7.7,1.1,1.6,1.1,2.6Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.8,796.6c0,1-.4,1.9-1,2.5-.7.6-1.5,1-2.5,1q-.9,0-1.6-.4-.7-.3-1.1-1c-.1-.2-.2-.5-.2-.9s0-.8,0-1.1q.1-.5.3-.9.1-.5.3-.9.1-.2.1-.3.1-.1.2-.3q0,0,0-.1.1,0,.1-.1q0,0,.1-.1q0-.1.1-.2q0,0,.1-.1q0,0,0-.1.1,0,.1,0q0-.1,0-.1.3-.2.7-.3.4,0,.8,0c1,0,1.8.4,2.5,1c.6.6,1,1.5,1,2.4Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751.8,796.4q-.6.1-1.2.3-.6.1-1.2.3-.4.1-.8.2-.4.2-.8.4-.6.2-1.1.5-.6.3-1,.7h-.1q-.2-.6-.3-1.1q0-.5.1-1q.1-.3.1-.5.1-.2.2-.4q0-.3.1-.5t.2-.4q.1-.1.1-.3.1-.1.1-.2q0,0,.1,0q0,0,0-.1q0,0,0-.1.1,0,.1-.1.4-.3.9-.5t1.1-.4c.9,0,1.7.4,2.3.9.6.6,1,1.4,1.1,2.3Z",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M750.5,796.6c0,.6-.3,1.2-.7,1.6s-.9.6-1.5.6-1.2-.2-1.6-.6c-.3-.4-.6-1-.6-1.6s.3-1.1.6-1.5c.4-.4,1-.7,1.6-.7s1.1.3,1.5.7.7.9.7,1.5Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.5,793.2q-.5.2-1,.3-.5.2-1.1.4-.5.1-1.1.2t-1.1.2q-.7.2-1.5.4-.7.3-1.4.6-.3.2-.5.4-.3.3-.5.6-.2.1-.3.3-.1.1-.3.3c0,0-.1.1-.2.2s-.2.2-.2.3q0,0,0-.2t.1-.6q.1-.9.5-1.6.3-.8.8-1.4c.6-.9,1.5-1.6,2.5-2.1c1.1-.4,2.2-.7,3.3-.7.3-.1.7,0,1,.1.4.2.6.4.7.8q.1.4.2.7.1.4.1.8Z",
    fill: "url(#eUaBTMDQpJe85-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M745.4,797.4q.1-.2.3-.3.2-.2.4-.3t.4-.3q.2-.1.4-.3.3-.2.7-.3.3-.2.7-.3c.8-.3,1.5-.5,2.3-.6.7-.1,1.4-.2,2.2-.3q.4,0,.9-.1t.9-.3q.3-.1.4-.3.2-.2.3-.4.1-.1.1-.3.1-.1.1-.2t.1-.2q0-.1,0-.3-.4.3-.9.5-.5.1-1,.3-.6.1-1.2.2t-1.2.3c-.8.1-1.7.3-2.5.6-.9.2-1.7.6-2.3,1.2-.2.2-.4.4-.5.6-.2.2-.3.4-.5.6q0,.1-.1.3-.1.1,0,.2Z",
    fill: "#020102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M751,795.8q.1.2,0,.5q0,.2-.3.3-.2.1-.4,0t-.3-.3-.1-.4q.1-.2.3-.3.3-.1.5-.1.2.1.3.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M726.5,795.8q.1.2,0,.4t-.3.3-.4.1q-.2-.1-.3-.3-.1-.3-.1-.5.1-.2.3-.3t.5,0q.2,0,.3.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M740.2,818.7c.1.1,0,.2,0,.3-.1.2-.1.3-.1.3-.3.3-.6.6-.9.8s-.6.4-.9.6q-.5.2-1,.4t-1,.3-1,.1-1,0q-1-.1-1.9-.4t-1.7-.8q-.7-.5-1.1-1.2-.4-.6-.6-1.3-.1-.5-.2-1t-.2-.9q0-.5,0-.9-.1-.5,0-.9.1-.1.1-.2.1-.1.2-.1c.1,0,.2.1.2.3.1.1.1.3.2.3q.7,1.3,1.9,2.2q1.1.9,2.5,1.4q1.5.6,3.2.8q1.7.1,3.3-.1Z",
    fill: "#b22842"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M736.9,819.3q0,.3,0,.7-.1.3-.2.7-.1.2-.2.3-.1.2-.2.4-.5.1-1,.1t-1,0q-1-.1-1.9-.4t-1.7-.8c-.7-.6-1.2-1.3-1.6-2-.3-.8-.5-1.6-.5-2.4q-.1-.3-.1-.6t0-.6q0-.2.1-.5q0-.2.2-.4.1-.1.1-.1t0,0q.1.1.1.1.1.1.1.2.3.4.6.9.4.4.8.8.4.5.9.8.5.4,1,.7q1,.5,2.2.8q1.1.4,2.2.5.1.2.1.4t0,.4Z",
    fill: "url(#eUaBTMDQpJe91-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.5,813.1q0,0,0-.1t0-.1q0-.1,0-.1q0-.1,0-.2.1-.1.1-.2t.1-.2.1-.3q.1-.1.2-.1.2-.2.4-.3.3-.1.6,0q.1,0,.2,0q.2,0,.3.1.1,0,.1,0q.1,0,.1.1.1,0,.2.1.1,0,.1,0c0,0-.2,0-.5,0-.2.1-.5.1-.6.1q-.3.1-.6.3-.2.2-.5.4-.1.1-.2.2-.1.2-.1.3Z",
    fill: "url(#eUaBTMDQpJe92-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.5,818.2c0,0,0,.2-.1.4s-.2.5-.4.7q-.7.1-1.5.1t-1.6-.1q-.2,0-.5-.1-.2,0-.5,0-1-.2-2-.5-.9-.4-1.8-1-.3-.1-.5-.2-.2-.2-.4-.3-.6-.5-1.1-1t-.8-1.2q-.2-.2-.3-.5-.2-.4-.3-.7.1,0,.2-.1q0-.1.1-.1c.4.8,1,1.5,1.7,2.1s1.5,1.1,2.3,1.5q.9.4,1.9.6.9.2,1.9.4.3,0,.5,0q.3,0,.6,0q.3.1.6.1.4,0,.7,0t.6-.1q.4,0,.7,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.5,818.2q-.1.1-.1.1q0,.1-.1.2-.2,0-.4.1-.2,0-.3,0-.6.1-1.2.1t-1.3,0q-1.3,0-2.5-.3-1.3-.2-2.5-.7-.3-.1-.5-.2-.2-.2-.4-.3-.6-.5-1.1-1t-.8-1.2q-.2-.2-.3-.5-.2-.4-.3-.7.1,0,.2-.1q0-.1.1-.1c.4.8,1,1.5,1.7,2.1s1.5,1.1,2.3,1.5q.9.4,1.9.6.9.2,1.9.4.3,0,.5,0q.3,0,.6,0q.6.1,1.3.1.7-.1,1.3-.1Z",
    fill: "url(#eUaBTMDQpJe94-fill)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M697.5,845.8c0,0,16.4,13.7,42.5,33.3c0,0,2.4-29.3-3.4-38.6-.4,1.3-3.3,11.5-5.6,11-2.5-.5-33.5-5.7-33.5-5.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724.3,864.6c1-1.9,4-6.5,5.1-8.3.7-1.2,1.4-3.1,2.5-4c.9-.6,1.6-.3,2.5.2c1.6.8,3.2,1.7,4.6,2.7c1,.8.4,1.7-.7,1.1-1.4-.8-3.5-1.3-5.1-1.8-.9,1.1-1.6,2.7-2.3,3.9-.9,1.5-3.6,5.8-4.5,7.3-.8,1.3-2.9.2-2.1-1.1Z",
    fill: "#f1e6dc"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.15084-100.090023)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M729.4,640.4c.9-.3,14.4,7.7,30.1,17.2c5.2,1.1,10.6,1.8,15.7,3.2c4.7,1.4,9.7,3.2,13,6.8c2.5,2.8,3.3,6.3,3.6,9.8c10.3,6.5,17.8,11.1,17.8,11.1-.6.4-38.4,64.5-41.4,63.3s-75.9-40.2-75.3-42.8c.5-2.6,34.2-68,36.5-68.6Z",
    transform: "translate(0-4.808404)",
    fill: "#313738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M775.2,660.8c4.7,1.4,9.7,3.2,13,6.8c2.5,2.8,3.3,6.3,3.6,9.8l-32.3-19.8c5.3,1.1,10.6,1.8,15.7,3.2Z",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.2,654.6c-.7-.3-1.3-.7-1.8-1.4-.4-.7.1-1.5.9-1.6q.2-.1.5-.1-.5-.4-1-.8c-.9-.8.1-2.3,1.2-1.7q1.7,1,3.3,2.3.8.6,1.4,1.3.5.4.9.9.2.1.3.3c.4.1.7.4.7.9q0,0,.1.1q0,.3-.2.6c6.3,2.3,12,6.4,15.2,12.4c1.5,2.9,2.3,6,2.4,9.2.1,4.1-.5,7.9,2.3,11.3c2.4,3,6.2,5.7,10,6.6c4.3,1,9,.1,13.3-.3c5.4-.5,13.6-2.5,17.9,1.9q.2-.2.3-.2c.6-.4,1.3-.3,1.8.1q.1,0,.2.1c1.3.8,1.7,2.6.6,3.8s-3.1,1-4-.4c-.3-.6-.4-1.3-.2-2-2.9-2.6-7.1-2-10.7-1.7-4.2.4-8.3.8-12.4,1.1-7.1.4-13.3-1.8-18.1-7.2-4.7-5.3-2-11.8-3.9-18-2.2-7.1-8.2-11.8-14.8-14.5q0,0,0,0c-1.8.7-3.8,1-5.8.8-1.2-.1-3.9-.3-4.5-1.7-.9-1.7,1.5-2.1,4.1-2.1Z",
    fill: "#ed1c24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.2,677.3c2-4.3,4.7-8.4,7-12.6q3.3-5.8,6.7-11.7q1.7-2.9,3.3-5.8c.6-1,1.2-2.5,2.4-2.9c1.4-.4,2.9.7,4,1.3c2,1,3.9,2.1,5.8,3.3c16,9.2,31.8,18.8,47.2,29.1c1,.6.2,1.9-.8,1.2-14.3-9.1-28.6-17.6-43.3-26.1q-2.7-1.6-5.4-3.1c-1.7-1-3.5-2.4-5.4-3.1-1.4-.5-1.4-.4-2.3.8-.6.8-1.1,1.9-1.6,2.7q-1.5,2.7-3.1,5.4-3,5.4-6.1,10.8c-2.2,3.8-4.7,7.8-7.2,11.5-.7,1-1.7.4-1.2-.8Z",
    opacity: 0.6,
    fill: "url(#eUaBTMDQpJe102-fill)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M658.2,925.6c18.3,27,36.5,50.1,54.7,59.9h-34.7l-20-59.9Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768,831c-.5-.5,4.7-3.2,6.5-9.3c1-3.4.1-4.8,1.7-6.9c1.9-2.6,4.2-1.5,6.7-4.1s1.4-4.9,3.6-9c1.9-3.6,4.8-5.3,6.5-6.5c6.2-4.4,10.8-12.3,16.9-22.6c14-23.9,11.2-59.5,16-59.8c2.2-.2,5,7,6.2,14c6.2,36.1-29.9,69.6-37,73-.7.3-3.4,1.5-5.5,4.2s-1.3,4-3.1,6.6c-2.7,3.6-5.2,2.4-7.6,5.7-2.2,3.1-.4,4.9-2.4,8.7-2.6,4.7-8.1,6.6-8.5,6Z",
    opacity: 0.6,
    fill: "url(#eUaBTMDQpJe106-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.3,931.8c-2.7,4,23.1,32.5,58.2,39.2c5.4,1,16.1,3.1,17.1.7c2.5-6.7-71.2-46-75.3-39.9Z",
    opacity: 0.6,
    fill: "url(#eUaBTMDQpJe107-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,791.3c4.7,2.6-22.7,43.1-8.8,59.3c12.5,14.7,46.5-4.5,57.4,10.3c6.9,9.4,2.2,29-8.3,34.4-18.8,9.7-67.6-19.9-69.2-56-1.3-27.3,25.1-50.2,28.9-48Z",
    opacity: 0.4,
    fill: "url(#eUaBTMDQpJe108-fill)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcademy2);
export default __webpack_public_path__ + "static/media/academy2.0ac7857c6a5f36377d681e1b62bc804c.svg";
export { ForwardRef as ReactComponent };